<div class="container" id="main">
    <div class="mx-auto" style="width: 500px;">
        <div class="card" style="width: auto; margin-top: 20%;">
            <h4 class="card-header" style=" background-color: #f4f4f4;">
                <img src="../../../assets/img/Freemove_logo.png" width="200">
            </h4>
            <div class="card-body" style="color: #070606; position: unset;">
                <div class="form-group">
                    <form [formGroup]="loginForm">
                        <div class="form-group">
                            <label for="username">Username</label>
                            <input type="text" formControlName="username" class="form-control" id="username"
                                name="username" placeholder="Username *">

                        </div>
                        
                        <div class="form-group mt-2">
                            <button class="btn btn-primary" [disabled]="loginDisabled()"
                                style="background-color: #13589D;" (click)="login()">
                                Recovery Password
                            </button>
                        </div>

                    </form>

                </div>
            </div>
            <!-- end form card -->
        </div>
        <!-- end mx auto -->
    </div>
</div>

<ngx-spinner name="sp1" style="margin-top: 100px;" bdOpacity=0.9 bdColor="#ffffff" size="default" color="#13589d"
      type="ball-clip-rotate" [fullScreen]="true">
      <p style="color: black;text-align:center;" class="loadingSpinnerText">
        <img
        src="../../../assets/FASWhiteLabelPortal/freemove-logo.svg"
          width="180" class="d-inline-block align-top" alt="" style="margin-top: 20%;"><br>
        Loading...
      </p>
</ngx-spinner>